import { IFileUpload } from "../../features/FileUpload/components/FileUpload.type";
import { DOCU_SIGN_FIELD_TYPES } from "../../components/PdfViewer/enums";
import { LoadState } from "../../constants/enums";

export interface IG4SignDocument {
  document_code: string | null;
  customer_id: number | null;
  customer_name: string | null;
  customer_code: string | null;
  customer_policy_id: any | null;
  policy_number: string | null;
  policy_status: string | null;
  line_of_business: string | null;
  title: string;
  document_type: string | null;
  sub_type: string | null;
  transaction_effective_date: string | null;
  attachment: IFileUpload[];
  producer_id: string | null;
  producer: string | null;
  producer_one_id: string | null;
  branch_id: string | null;
  branch: string | null;
  status: string;
  type: string | null;
  preview_attachment?: string;
  signed_document_url: string | null;
  effective_date: string | null;
  expiry_date: string | null;
  insurer: string | null;
}

export interface IG4SignDocumentRecipient {
  recipient_code?: string | null;
  document_code: string;
  email: string;
  signer_name: string | null;
  expired: string | null;
  send_status: string | null;
  status: "ACTIVE" | "INACTIVE";
}

export interface IG4SignDocumentRecipientGet {
  recipient_code: string;
  document_code: string;
  email: string;
  expired: string | null;
  status: "ACTIVE" | "INACTIVE";
  auth_key: string;
  browser: string | null;
  create_ts: string;
  created_by_id: number;
  insert_ts: string;
  latitude: string | null;
  longitude: string | null;
  read_status: any;
  send_status: string;
  sign_recipient_id: number;
  signed_at: string | null;
  signed_status: string;
  signer_name: string;
  sign_order: number;
  user_ip: string | null;
}

export interface IG4SignEditior {
  field_code: string | null;
  document_code: string;
  recipient_code: string;
  field_type: DOCU_SIGN_FIELD_TYPES;
  page_no: number;
  position_x: number;
  position_y: number;
  customer_text: string | null;
  isNewPlaceholder?: boolean;
  size_category: string;
  content?: string;
  title?: string;
}

export interface IG4SignState {
  list: IG4SignDocument[];
  totalRecords: number;
  loading: LoadState;
  document: IG4SignDocument;
  documentLoading: LoadState;

  errorMessage: string | null;
  recipientList: IG4SignDocumentRecipientGet[];
  recipientLoading: LoadState;
  editior: {
    placeholders: IG4SignEditior[];
    loading: LoadState;
    documentCode: string | null;
  };
}

export const initialG4SignDocumentState: IG4SignState = {
  list: [],
  totalRecords: 0,
  loading: LoadState.NotLoaded,
  document: {
    document_code: null,
    customer_id: null,
    transaction_effective_date: null,
    customer_name: null,
    customer_policy_id: null,
    customer_code: null,
    expiry_date: null,
    effective_date: null,
    policy_number: null,
    policy_status: null,
    line_of_business: null,
    title: "",
    document_type: null,
    sub_type: null,
    attachment: [],
    producer_id: null,
    producer: null,
    producer_one_id: null,
    branch_id: null,
    branch: null,
    type: "Customer",
    status: "ACTIVE",
    signed_document_url: null,
    insurer: null,
  },
  documentLoading: LoadState.NotLoaded,
  errorMessage: null,
  recipientList: [],
  recipientLoading: LoadState.NotLoaded,
  editior: {
    documentCode: null,
    placeholders: [],
    loading: LoadState.NotLoaded,
  },
};
